<template>
  <gj-modal
      :visible.sync="modalVisible"
      :loading="modalLoading"
  >
    <template #header>
      <span>{{detailData.code}}</span>
      <span style="margin-left: 10px">{{isMeaningful(detailData.opType) ? opTypeMap[detailData.opType].text : '-'}}</span>
    </template>
    <template #content>
      <gj-desc-group
          :label-width="'90px'"
      >
        <el-row>
          <el-col :span="12">
            <gj-desc label="来源单号">{{detailData.relevanceCode | defaultShow}}</gj-desc>
          </el-col>
          <el-col :span="12">
            <gj-desc
                label="仓库"
                :content="detailData.warehouseName | defaultShow">
            </gj-desc>
          </el-col>
        </el-row>
        <el-row>
          <gj-desc
            label="源单备注"
            :content="detailData.memo | defaultShow"
          ></gj-desc>
        </el-row>
        <el-row>
          <el-col :span="12">
            <gj-desc label="创建人">{{detailData.createUserName | defaultShow}}</gj-desc>
          </el-col>
          <el-col :span="12">
            <gj-desc label="创建时间">{{detailData.createTime | defaultShow}}</gj-desc>
          </el-col>
        </el-row>
      </gj-desc-group>
      <div>
        <gj-table
            :index="false"
            :offset-height="8"
            :data="detailData.items || []"
            :columns="columns"
        >
          <template v-slot:productInfo="{row}">
            <div>
              <gj-text width="100%" :content="row.productName">{{row.productName}}</gj-text>
            </div>
            <div>
              <gj-text width="100%" :content="row.sku">{{row.sku}}</gj-text>
            </div>
          </template>
        </gj-table>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {isMeaningfulMixin, modalMixIn} from "../../../../../minxins";
  import {getInboundDetail} from "../../../../../api/warehouse";
  import {transformToMap} from "../../../../../utils/common";
  import {opTypeOption} from "../enum";
  import {ProductEnum} from "../../../../../utils/options";

  export default {
    name: "inbound-outbound-detail",
    mixins: [modalMixIn, isMeaningfulMixin],
    props: {
      item: null,
    },
    created() {
      getInboundDetail(this.item.id)
        .then((data) => {
          this.detailData = data;
        }).complete(() => this.modalLoading = false)
    },
    data() {
      return {
        loading: true,
        modalLoading: true,
        detailData: {},
        columns: [
          {id: 'picture', header: '图片', field: 'picture:skuImageUrl', minWidth: '50px'},
          {id: 'sku', header: 'SKU', field: 'sku', width: '160px'},
          {id: 'productInfo', header: '产品名称', field: 'slot:productInfo', minWidth: '160px'},
          {id: 'productType', header: '产品类型', field: 'option:productType', minWidth: '100px', options: ProductEnum.typeOption},
          {id: 'categoryName', header: '品类', field: 'categoryName', minWidth: '140px'},
          {id: 'changeQuantity', header: '良品量', field: 'changeQuantity', minWidth: '100px', align: 'right'},
          {id: 'changeBadQuantity', header: '次品量', field: 'changeBadQuantity', minWidth: '100px', align: 'right'},
          {id: 'changePurchaseCost', header: '采购成本',prefix: 'currencySymbol', field: 'changePurchaseCost', width: '115px', align: 'right'},
          {id: 'changeArriveCost', header: '到库成本',prefix: 'currencySymbol', field: 'changeArriveCost', width: '115px', align: 'right'},
          {id: 'changeTotalPurchaseCost', header: '总采购成本',prefix: 'currencySymbol', field: 'changeTotalPurchaseCost', width: '115px', align: 'right'},
          {id: 'changeTotalArriveCost', header: '总到库成本',prefix: 'currencySymbol', field: 'changeTotalArriveCost', width: '115px', align: 'right'},
        ],
        opTypeMap: transformToMap(opTypeOption),
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-row{
    margin-bottom: 16px;
  }
  /deep/ .el-form-item__label, /deep/.el-form-item__content{
    line-height: 14px;
  }
</style>
